import { createIcon } from "@chakra-ui/icons";

// Created from mIconTemporalRaster.svg (part of QGIS icons)

export const ScenarioIcon = createIcon({
  displayName: "SCENARIO",
  viewBox: "0 0 17 17",
  path: (
    <g id="scenario">
      <g clipPath="url(#clip0_6949_7276)">
        <path
          d="M2.46667 2.6001H6.79967V6.9331H2.46667V2.6001ZM6.79967 6.9331H11.1337V11.2671H6.79967V6.9331ZM11.1337 2.6001H15.4667V6.9331H11.1337V2.6001Z"
          fill="#2B3B4D"
        />
        <path
          d="M2.46667 6.9331H6.79967V11.2671H2.46667V6.9331ZM11.1337 6.9331H15.4667V11.2671H11.1337V6.9331ZM6.79967 11.2671H11.1337V15.6001H6.79967V11.2671ZM6.79967 2.6001H11.1337V6.9331H6.79967V2.6001Z"
          fill="#AEC7E2"
        />
        <path d="M2.46667 11.2671H6.79967V15.6001H2.46667V11.2671Z" fill="#2B3B4D" />
        <path
          d="M10.6157 16.11C13.5566 16.11 15.9407 13.7931 15.9407 10.935C15.9407 8.07694 13.5566 5.76001 10.6157 5.76001C7.67476 5.76001 5.29068 8.07694 5.29068 10.935C5.29068 13.7931 7.67476 16.11 10.6157 16.11Z"
          fill="white"
          stroke="#343434"
        />
        <path
          d="M10.2557 11.3652V7.83716M12.6627 13.2892L10.2587 11.3692"
          stroke="#343434"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6949_7276">
          <rect width="16" height="16" fill="white" transform="translate(0.466675 0.600098)" />
        </clipPath>
      </defs>
    </g>
  ),
});
